// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3YxAP","content":"styles_content__17W7i","selectAll":"styles_selectAll__2lHwZ"};